import { Connect } from "@quan-to/connect-web-embedded";

const Quanto = Connect;

export { Quanto };
